import axiosInstance from '../Axios';
import Const from '../config/const';
import {
  clearPendingApplication,
  getPendingApplication,
  isKnownApplication,
  resolveApplicationConstKey,
} from './PendingApplication';

// Hands off to a client app with a single-use OTT code — never a JWT. The
// app's backend exchanges the OTT server-to-server for the real API token.
export const redirectToApplication = async (application: string) => {
  // No configured URL for this app means there is nowhere to send the user;
  // attempting it would navigate to "undefined?ott=…".
  const constKey = resolveApplicationConstKey(application);
  if (!constKey) {
    clearPendingApplication();
    return false;
  }
  try {
    // The API and the `application` DB table use lowercase names; Const keys do
    // not always match that casing (linenIq vs lineniq). For linentech — the
    // only integrated app today — both are already 'linentech', so this is a
    // no-op there. Mirrors what AllProduct.tsx does for the portal's own tiles.
    const apiName = application.toLowerCase();
    const response = await axiosInstance.post('/product/get-token' , {"application":apiName});
    const ott = encodeURIComponent(response.data.data);
    // The handoff is happening, so the app no longer needs remembering —
    // otherwise coming back to this tab later would bounce out of the portal.
    clearPendingApplication();
    window.location.href = Const[constKey] + '?ott=' + ott;
    return response;
  } catch (error: any) {
    // A 401 means the SSO session is gone, not that the app is unreachable:
    // keep the pending app so signing in again returns the user to it.
    // Anything else — 403 "you don't have access to login this application",
    // app misconfigured — is not fixed by re-authenticating, so drop it rather
    // than leave the user stuck retrying an app they can never reach.
    if (error?.response?.status !== 401) {
      clearPendingApplication();
    }
    return false;
  }
};

export const isLogedIn = () => {
  if(localStorage.getItem("token") && localStorage.getItem("user")){
    return true;
  }
  return false;
};

export const manageLoginData = async (data: any, application?: string | null) => {
  localStorage.setItem('token', data.token);
  localStorage.setItem('user', JSON.stringify(data.user));
  // Fall back to the remembered app: by the time a login completes the URL may
  // no longer carry ?application= (a 2FA step or a reload can have dropped it).
  const target = isKnownApplication(application) ? application : getPendingApplication();
  if (target) {
    // The session token is stored above, so this authenticated call gets a
    // fresh app-bound OTT and redirects with ?ott=.
    const redirected = await redirectToApplication(target);
    if (!redirected) {
      window.location.href = '/home';
    }
  } else {
    window.location.href = '/home';
  }
};
